import React, { useState } from "react";

import { Form, Col, Row, Checkbox, Space, Divider } from "antd";

import { setchecklistModal } from "../../../TaskmanagementVendor.Slice";
import {
  GuesttaskActions,
  checklistSubmit,
  getDetails,
  taskActions,
} from "../../../TaskmanagementVendor.Action";
import "./checklist.less";
import { useDispatch } from "react-redux";
import CustomModal from "./../../../../../globals/components/Modal/index";
import CustomButton from "../../../../../globals/components/button";

import {
  dateFormatter,
  formatArrayvalueToString,
} from "../../../../../utils/helper";

const ChecklistModal = (props) => {
  const dispatch = useDispatch();
  const {
    intl: { formatMessage },
    taskmanagementVendor,
    user,
    local:{_locale}
  } = props;
  const {
    taskTicketDetails = {},
    isChecklistVisible,
    isChecklistLoading,
    Checklistfiltereddata = [],
    checklistModalType,
    taskPagination,
    DrawerRecord,
  } = taskmanagementVendor;
  const { vendor_details } = user;
  const Checklistfilldata = taskTicketDetails?.vendorApprovalData?.filter(
    (item) => item.vendorId === vendor_details._id
  );

  const checklistnewdata =
    Checklistfilldata[0]?.vendorChecklistWithValue?.length > 0
      ? Checklistfilldata[0].vendorChecklistWithValue
      : Checklistfiltereddata;
  const [checkedItems, setCheckedItems] = useState([]);
  const isAllChecked =
    checklistnewdata[0].checkListData.length === checkedItems.length;
  const indeterminate =
    checkedItems.length > 0 &&
    checkedItems.length < checklistnewdata[0].checkListData.length;
  const onCheckAllChange = (e) => {
    setCheckedItems(
      e.target.checked
        ? checklistnewdata[0].checkListData.map((item) => item._id)
        : []
    );
  };
  // const { Checklistfiltereddata = [] } = taskTicketDetails;

  // const canvasRef = useRef(null);
  // const [content, setContent] = useState("");
  const modelClose = async (form) => {
    // form.resetFields();
    dispatch(setchecklistModal({ visible: false, record: {} }));

    if (
      ["actionforemail", "checklistactionforemail"].includes(checklistModalType)
    ) {
      // dispatch(
      //   getGuestTaskDetails({
      //     taskId: taskTicketDetails._id,
      //   })
      // );
    } else {
      dispatch(
        getDetails({
          taskId: DrawerRecord?._id,
          companyIds: user?.company_ids,
          companyId: taskTicketDetails?.companyId,
          vendorId: vendor_details?._id,
        })
      );
    }
  };

  const handleDynamicLevelData = (data, invoiceStatus) => {
    const cust_emp_id = vendor_details._id;
    let currentData = [];
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let eve = data[i];
        let is_stratargy = eve.strategy;
        let approved_user_details = eve.approvalVendorIds
          ? eve.approvalVendorIds.length
          : 0;
        if (Number(is_stratargy) !== Number(approved_user_details)) {
          currentData.push(eve);
          break;
        }
      }
    }
    let rstData =
      currentData.length &&
      currentData.find((eve) => eve.vendor_ids.includes(cust_emp_id));
    if (rstData && rstData.strategy) {
      var approval_ids = rstData.approvalVendorIds
        ? rstData.approvalVendorIds
        : [];
      const staff_id =
        rstData.vendor_ids && rstData.vendor_ids.length > 0
          ? rstData.vendor_ids
          : [];
      if (
        approval_ids.length >= 0 &&
        !approval_ids.includes(cust_emp_id) &&
        approval_ids.length <= rstData.strategy &&
        staff_id.includes(cust_emp_id)
      ) {
        if ([1, 2].includes(Number(invoiceStatus))) {
          return rstData;
        }
      }
    }
    return {};
  };
  const { approvals = [] } = taskTicketDetails;
  let invoiceStatus = 1;

  const createChecklistSubmit = async (form) => {
    const staticDetailData = handleDynamicLevelData(approvals, invoiceStatus);
    await form.validateFields();
    let reqData = {
      vendorChecklistWithValue: Checklistfiltereddata,
      vendorId: vendor_details._id,
      taskId: taskTicketDetails._id,
      approvalId: staticDetailData._id || approvals[0]._id, //LevelId
      companyId: taskTicketDetails.companyId,

      isGuestUser:
        checklistModalType === "checklistactionforemail" ? true : false,
    };

    await dispatch(checklistSubmit({ reqData, type: checklistModalType }));

    if (checklistModalType === "action") {
      let rscData = {
        taskId: taskTicketDetails._id,
        vendorId: vendor_details._id,
        action: 2,
        approvalId: staticDetailData._id || approvals[0]._id, //LevelId
        companyId: taskTicketDetails.companyId,
      };
      const newtaskPagination = {
        ...taskPagination,
        companyIds: user.company_ids,
        vendorId: vendor_details._id,
      };
      await dispatch(
        taskActions({
          rscData,
          taskReq: {
            taskId: taskTicketDetails._id,
            companyIds: user.company_ids,
            companyId: taskTicketDetails.companyId,
            vendorId: vendor_details._id,
          },
          newtaskPagination,
        })
      );
    }

    if (checklistModalType === "actionforemail") {
      let rscData = {
        taskId: taskTicketDetails._id,
        vendorId: vendor_details._id,
        action: 2,
        approvalId: staticDetailData._id || approvals[0]._id,
        isGuestUser: true,
        companyId: taskTicketDetails.companyId,

        //LevelId
      };
      const newtaskPagination = {
        ...taskPagination,
        companyIds: user.company_ids,
        vendorId: vendor_details._id,
        isGuestUser: true,
      };
      await dispatch(
        GuesttaskActions({
          rscData,
          taskReq: {
            taskId: taskTicketDetails._id,
            companyIds: user.company_ids,
            companyId: taskTicketDetails.companyId,
            vendorId: vendor_details._id,
            isGuestUser: true,
          },
          newtaskPagination,
        })
      );
    }
  };
  const [form] = Form.useForm();
  const staticDetailData = handleDynamicLevelData(approvals, invoiceStatus);
  let is_approval_strategy = true;
  const appoveLevelCondition = () => {
    let findActualData =
      checklistnewdata?.length > 0 ? checklistnewdata[0]?.checkListData : "";
    let matchArrayVal =
      findActualData?.length > 0
        ? findActualData.every(
            (eve) => eve?.value?.length === eve?.options?.length
          )
        : "";
    if (!matchArrayVal) {
      return false;
    }
    if (is_approval_strategy && approvals.length) {
      return staticDetailData.strategy;
    } else {
      if ([1, 2].includes(Number(invoiceStatus))) {
        return true;
      }
      return false;
    }
  };

  // const [checkedList, setCheckedList] = useState([]);

  // Handle checkbox change
  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setCheckedItems([...checkedItems, id]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== id));
    }
  };

  // Check if all checkboxes are selected

  const findcontractType = (contractType) => {
    if (contractType === 1) {
      return "years";
    } else if (contractType === 2) {
      return "months";
    } else if (contractType === 3) {
      return "days";
    } else {
      return "--";
    }
  };
  return (
    <CustomModal
      title={
        <>
          <Row>
            <Col span={12}>{formatMessage({ id: "checklist" })}</Col>
            <Col span={8}></Col>
            <Col span={3}>
              <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={isAllChecked}
              >
                {
                  formatMessage({
                    id:"check_all"
                  })
                }
              </Checkbox>
            </Col>
          </Row>
        </>
      }
      onCancel={() => {
        modelClose(form);
      }}
      width={800}
      open={isChecklistVisible}
      maskClosable={false}
      footer={
        <div>
          <CustomButton
            // type="primary"
            onClick={() => {
              modelClose(form);
            }}
          >
            {formatMessage({ id: "cancel" })}
          </CustomButton>
          <CustomButton
            disabled={!isAllChecked}
            type="primary"
            onClick={() => createChecklistSubmit(form)}
            key={"submit"}
            loading={isChecklistLoading}
          >
            {formatMessage({ id: "submit" })}
          </CustomButton>
        </div>
      }
    >
      {" "}
      <div className="verify_checklist_title">
      {
        formatMessage({
          id:"verify_text_rule"
        })
      }
        
      </div>
      <Divider />
      <Form
        form={form}
        // title={formatMessage({ id: "task_template_name" })}
        labelAlign="left"
        // disabled={true}
        name="step1form"
        layout="vertical"
        autoComplete="off"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {checklistnewdata?.length > 0 ? (
            checklistnewdata.map((item, parentindex) => (
              <div key={parentindex}>
                {item.checkListData?.map((item) => (
                  <Form.Item valuePropName="checked" key={item._id}>
                    <Checkbox
                      onChange={(e) => handleCheckboxChange(e, item._id)}
                      checked={checkedItems.includes(item._id)}
                    >
                      {`${
                        item?.translation?.[_locale]?.label ||
                        item?.translation?.en?.label ||
                        item.label
                      } is `}
                      {[0, 1, 2, 5, 8, 9, 10, 14, 12, 3].includes(
                        item?.dataType
                      ) && <span className="key_value">{item.value}</span>}
                      {[7, 15].includes(item?.dataType) && (
                        <span className="key_value">
                          {item?.value
                            ? dateFormatter(item.value, "DD/MM/YYYY")
                            : "-"}
                        </span>
                      )}

                      {[13].includes(item?.dataType) && (
                        <span className="key_value">
                          {item.value} {formatMessage({id:findcontractType(item?.contractType)})}
                        </span>
                      )}
                      {[6].includes(item?.dataType) && (
                        <span className="key_value">
                          {item?.typeOfOptions === "Multiple"
                            ? formatArrayvalueToString(item.value || [])
                            : item.value}
                        </span>
                      )}
                    </Checkbox>
                  </Form.Item>
                ))}
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", marginTop: "25px" }}>
              <p>{formatMessage({ id: "noDataFound" })}</p>
              <img
                alt={formatMessage({ id: "noData" })}
                src="data:image/svg+xml;base64,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"
              />
            </div>
          )}
        </Space>
      </Form>
    </CustomModal>
  );
};

export default ChecklistModal;
